import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';

type IAddLandingPageDesignsToGroup = {
  groupIds: number[];
  landingPageDesigns: number[];
};

const addLandingPageDesignsToGroup = async (
  body: IAddLandingPageDesignsToGroup
) => {
  return (
    await EXPRESS_API.post(
      '/superadmin/landing-page-design-groups/add-batch',
      body
    )
  ).data;
};

export const useAddBatchToGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(
    (data: IAddLandingPageDesignsToGroup) => addLandingPageDesignsToGroup(data),
    {
      onSuccess: async () => {
        successToast({
          title: 'Landing pages successfully added to group!',
        });
        await queryClient.refetchQueries(landingPageDesignGroupsKeys.all());
        await queryClient.refetchQueries({
          queryKey: 'LANDING_PAGE_DESIGNS',
          exact: false,
        });

        if (onSuccess) onSuccess();
      },
      onError: error => {
        showError(
          error ||
            'An error occured while trying to add landing pages to groups.'
        );
      },
    }
  );
};
